import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

import { AlertSeverity, AppAlert } from '../alerts.model';

@Component({
  selector: 'app-alert-banner',
  templateUrl: './alert-banner.component.html',
  styleUrls: ['./alert-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertBannerComponent {
  @Input() alert!: AppAlert;
  @Output() dismiss = new EventEmitter<number>();
  readonly AlertSeverity = AlertSeverity;

  constructor() {}

  onDismiss(): void {
    this.dismiss.emit(this.alert.alertId);
  }

  getIcon(severity: AlertSeverity): string {
    switch (severity) {
      case AlertSeverity.CRITICAL:
        return 'error';
      case AlertSeverity.WARNING:
        return 'warning';
      case AlertSeverity.INFO:
      default:
        return 'info';
    }
  }

  getRole(severity: AlertSeverity): 'alert' | 'status' | null {
    switch (severity) {
      case AlertSeverity.CRITICAL:
        return 'alert';

      case AlertSeverity.INFO:
        return 'status';

      default:
        return null;
    }
  }
}
